
import axios from 'axios'


//const BASE_URL = "http://localhost:8081/";
const BASE_URL = "https://youyuanren-office-cloud.com/time/";

var loadingMode = null;
var count = 0;

export function request(that,method,url, data) {
	let pam = {
			url: BASE_URL + url,
			method,
			headers: {
			  'Content-Type': 'application/json',
			},
		};
	
	if(method == 'post'){
		pam.data = data;
	}else{
		pam.params = data;
	}
	
	return new Promise((resolve, reject) => {
		if(count == 0){
			loadingMode = that.$message({
			  message: 'loading...',
			  duration:0,
			});
			count++;
		}else{
			count++;
		}
		
		
		// 发送Axios请求
		axios(pam)
		.then(function (response) {
			
			//请求完成
			if(response.status == 200){
				resolve(response.data);
			} else if(response.status == 401){
				that.$message({
				  message: '登录失效',
				  type: 'info'
				});
				that.$router.push("/Login");
			} else{
				that.$message({
				  message: '系统错误，稍后重试',
				  type: 'info'
				});
			}
			
			let data = response.data;
			if(data.code == 401){
				that.$message({
				  message: data.msg,
				  type: 'info'
				});
				that.$router.push("/Login");
			}
			
			resolve(response.data.data)
		})
		.catch(function (error) {
			console.log(error)
			that.$message({
			  message: '未知错误，稍后重试',
			  type: 'info'
			});
		}).finally(function () {
			
			count--;
			if(count <= 0){
				count = 0;
				loadingMode.close();
			}
		})
	
	
	
	
	
  })
}



export function getManagerUrl(){
	return managerUrl;
}

export function getDetailTime(date){
	if(date == null){return null;}
  date = new Date(date);
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return year+"-"+(month < 10?("0"+month):month)+"-"+(day < 10?("0"+day):day);
}

export function getTime(date){
	if(date == null){return null;}
  date = new Date(date);
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

  return year+"-"+(month < 10?("0"+month):month)+"-"+(day < 10?("0"+day):day)+" "+(hour < 10?("0"+hour):hour)+":"+(minute < 10?("0"+minute):minute)+":"+(second < 10?("0"+second):second);
}

export function getMinuteTime(date){
	if(date == null){return null;}
  date = new Date(date);
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

  return (month < 10?("0"+month):month)+"-"+(day < 10?("0"+day):day)+" "+(hour < 10?("0"+hour):hour)+":"+(minute < 10?("0"+minute):minute);
}

export function getHourTime(date){
	if(date == null){return null;}
  date = new Date(date);
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

  return (hour < 10?("0"+hour):hour)+":"+(minute < 10?("0"+minute):minute);
}







// 默认导出所有方法
export default {
  request,
  getDetailTime,
  getTime,
  getMinuteTime,
  getHourTime,
  getManagerUrl
}























